import Column from "./default"

export default class RowHeader extends Column {
	#cachedCellRenderInfo = {}

	get groupId () {
		return this.options.groupId || this.id
	}

	get isRowNum () {
		return !!this.options.isRowNum
	}

	get readonly () {
		return true
	}

	constructor ({ options }) {
		super({ options })
	}

	renderCell (ctx, props) {
		if (this.isRowNum) {
			props.value = props.rowIndex + 1
			return this.renderCellDefault(ctx, props)
		}
		const groupId = this.getGroupIdValue(ctx, props)
		if (this.#cachedCellRenderInfo.groupId == null) {
			// キャッシュがなければ作成して終了（レンダリングはしない）
			this.createCache(ctx, props, false)
		} else if (groupId === this.#cachedCellRenderInfo.groupId) {
			// グループIDがキャッシュと同じならキャッシュの値を更新して終了（レンダリングしない）
			this.updateCache(props)
		} else if (groupId !== this.#cachedCellRenderInfo.groupId) {
			// グループIDがキャッシュと違うならキャッシュをレンダリング
			this.flush(ctx)
			// 自身のキャッシュを新規作成して終了
			this.createCache(ctx, props, true)
		}
	}

	renderMultilineCell (ctx, {
		offsetTop,
		offsetLeft,
		height,
		value,
		color,
		bgColor,
		rowIndex
	}) {
		ctx.useContext2d(ctx2d => {
			// セル描画
			ctx2d.strokeStyle = ctx.gridStyle.borderColor
			ctx2d.lineWidth = ctx.gridStyle.borderLineWidth
			ctx2d.fillStyle = bgColor || ctx.gridStyle.bgColor
			ctx.fillRect(offsetLeft, offsetTop, this.actualWidth, height)
			ctx.strokeRect(offsetLeft, offsetTop, this.actualWidth, height)
			const text = value != null ? String(value) : ""

			this.renderMultilineTextForCell(ctx, {
				offsetTop,
				offsetLeft,
				height,
				width: this.actualWidth,
				value: text,
				color: ctx.gridStyle.txtColor
			})
		})
	}

	createCache (ctx, props, isTop) {
		const groupId = this.getGroupIdValue(ctx, props)
		this.#cachedCellRenderInfo = {
			...props,
			groupId: groupId
		}
		if (isTop || props.rowIndex === 0) {
			return
		}

		// グループの開始セルの位置を考慮する
		let count = 0
		while (props.rowIndex - count - 1 >= 0) {
			const upperRow = ctx.rows[props.rowIndex - count - 1]
			const value = upperRow.data[this.groupId]
			// 上の行と同じ値か
			if (groupId === value) {
				count++
			} else {
				// 違ったら終了
				break
			}
		}
		this.#cachedCellRenderInfo.offsetTop -= props.height * count
		this.#cachedCellRenderInfo.height = props.height + props.height * count
	}

	updateCache (props) {
		this.#cachedCellRenderInfo.height += props.height
	}

	flush (ctx) {
		if (this.isRowNum) return
		this.renderMultilineCell(ctx, this.#cachedCellRenderInfo)
		this.#cachedCellRenderInfo = {}
	}

	getGroupIdValue (ctx, props) {
		// valueをgroupIdの値に置き換え
		const row = ctx.rows[props.rowIndex]
		return row.data[this.groupId] || props.value
	}
}
